import React, { useCallback, useMemo, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryInput from "../components/EntryInput";
import EntryGrid from "../components/EntryGrid";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
     isEmpty, getformid, getcontroller, getsubkey,  getWindowDimensions, setglobaldata,
     NumConv, DicVal, getglobaldata,  DeepCopy, initializedata, RandomKey, Savestorage, Getstorage
} from '../modules/appLibrary';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entryformlock } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';
import { readonly } from '../modules/formstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));


export const StockFix = props => {

    const panelsdef = [{ id: "0", name: "ヘッダ情報", name2: "Hedder", hide: false },
        { id: "1", name: "対象在庫拠点", name2: "Rows", hide: false },
    ]
    const G_id = { BASE: "0", ROW: "1"}
    //const primarykeys = ["d_move_p_no", "d_move_p_row_no"];

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const staff = useSelector(state => state.user.accctl);
    const warndescription = useSelector(state => state.form.warndiscription);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const themestyle = useSelector(state => state.form.themestyle);
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const apiRefrow = useRef({ grid: undefined, column: undefined });
    const apirow = apiRefrow.current;
    const locationstate = useRef(null);    //遷移State

    const entrydataRef = useRef(null);    //基本情報データ
    const rowsRef = useRef(null);         //在庫拠点データ
    const colRef = useRef(null);          //在庫拠点列情報  

    const formstatus = useSelector(state => state.form.status);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [update, setUpdata] = useState(false);
    const [layoutlock, setlayoutlock] = useState(false);
    const [all, setall] = useState(false);
    const search = useLocation().search;

    const dispatch = useDispatch();
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const formid = getformid("StockFix", props.location.search);
    const controller = getcontroller("StockFix", props.location.search);
    const subkey = getsubkey(props.location.search);

    const actionurl = {
        "delete": "stockfix/Delete",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "release", icon: "cancel", label: "確定解除", title: "選択された確定の解除をおこないます" },
    ]

    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "0", action: "UPDATE" }
    ];

    function rerender() {
        setUpdata(update ? false : true);
    }
    function statusKey(id) {
        return formid + "entry_" + id;
    }

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
    }, [menuinfo]);



    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    //列情報初期化
                    colRef.current = null;
                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus("NEW FORM"));
                        }
                    }
                    fnc.current.wait(false);
                }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    function setsliplock(value) {
        dispatch(entryformlock(value));
    }

    function onFirstDataRendered(param, id) {
        if (id === G_id.ROW) {
            apiRefrow.current.grid = param.api;
            apiRefrow.current.column = param.columnApi;
        }
    }

    function MenuAction(action, finallycallback, reload, gridApi) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === "clear") {
            clearform();
            rerender();
        }
        if (action === 'linkfield') {
            if (finallycallback.field === "ft_invfix_warehouse") {
                Jump(G_id.ROW);
                AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, apirow.grid);
            } else {
                let type = "100";
                let col = textfields.find(e => e.columnid === finallycallback.field);
                if (col !== undefined) {
                    type = col.type;
                    let key = finallycallback.field + "_" + type;
                    document.getElementById(key).focus();
                    document.getElementById(key).select();
                }
                Jump(G_id.BASE, type);
            }
        }
        if (action === "release") {
            let rowdata = AGRef.current.GetSelectrowdata(gridApi);
            if (rowdata.length === 0) {
                fnc.current.warnmsg("確定解除するデータを選択してください");
                return;
            }
            fnc.current.confmsg("選択された" + rowdata.length + "行の確定解除を行います。データの復帰はできませんよろしいですか？", () => FixRelease(rowdata,reload));
        }
    }
    //確定解除処理
    function FixRelease(rowdata, reload) {
        const param = {
            "controller": props.controller,
            "rowdata": rowdata,
            "tabletype": "0"
        }
        fnc.current.postaxios(actionurl.delete, param,
            {
                onSuccess: function (data) {
                    fnc.current.success();
                    reload(false);
                    fnc.current.wait(false);
                },
                errmsg: "確定解除に失敗しました"
            }
        )
    }
    function Show(data, pushcode) {
        let code = "";
        clearform();
        if (isEmpty(columninfo)) return false;    //読み込み前
        //データ読み込み
        LoadData(code);
        return true;
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('stockfix/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                if ("d_move_p_memo" in row) data.data.d_move_p_memo = row.d_move_p_memo;
                                if ("d_move_p_sticky" in row) data.data.d_move_p_sticky = row.d_move_p_sticky;
                                if ("d_move_p_mytags" in row) data.data.d_move_p_mytags = row.d_move_p_mytags;
                            }
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = data.data;
                            rowsRef.current = data.rowdata;
                            dispatch(setimagelist(data.images));
                            var totalfields = ["d_move_p_qty"];
                            var totalcols = columninfo.filter(e => e.logpid === "T1");
                            for (let i = 0; i < totalcols.length; i++) {
                                if (totalfields.indexOf(totalcols[i].columnid) === -1)
                                    totalfields.push(totalcols[i].columnid);
                            }
                            var total = { rowid: "TOTAL", grip: "計" };
                            for (let i = 0; i < totalfields.length; i++) {
                                total[totalfields[i]] = data.data[totalfields[i]];
                            }
                            setsliplock(data.data["d_move_p_lock"] !== "0");   //伝票ロックか
                            rerender();
                        }
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }


　  //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (!edit) return edit;
        if (status === "UPDATE") {
            return false;
        }
        return edit;
    }

    function isAll() {
        if (isEmpty(entrydataRef.current)) return false;
        if (DicVal(entrydataRef.current, "ft_invfix_isall", "0") === "1") return true;
        return false;
    }
    function Save(finallycallback) {
        storeRowData();
        let row = rowsRef.current;
        if (!isAll()) {
            if (!AGRef.current.ExistValidRow(rowsRef.current, columninfo, colRef.current)) {
                fnc.current.warnmsg("対象在庫拠点を入力してください");
                return;
            }
        }
        Apply();

        function Apply() {
            if (isEmpty(entrydataRef.current)) entrydataRef.current = {};
            const paramdata = {
                "controller": formid,
                "data": entrydataRef.current,
                "rowdata": row,
                "colinfo": columninfo,
                "code": edittingcode
            }
            fnc.current.postaxios("stockfix/InsertEntry", paramdata,
                {
                    onSuccess: function (data) {
                        if (data.warning.length === 0) {
                            fnc.current.modify(false);
                            clearform();
                            fnc.current.success();
                        }
                        else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                        fnc.current.wait(false);
                    },
                    errmsg: "登録に失敗しました"
                }
            )
        }
    }



    //Grid Data Change
    function ChangeRowValue(params) {
        storeRowData(G_id.Row);
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined || panel === G_id.ROW) {
            rowsRef.current = AGRef.current.GetDatasource(apirow.grid);
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.ROW) panelid = 'rowGrid';
       let elem = document.getElementById(panelid);
        if (elem === undefined) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try {
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        } catch { }
    }
    //入力フィールドクリア
    function clearform() {
        setsliplock(false);
        entrydataRef.current = initializedata(textfieldsall, staff);
        rowsRef.current = [{ rowid: RandomKey() }];
        dispatch(setimagelist([]));
        fnc.current.modify(false);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        AGRef.current.SaveColState(statusKey(G_id.ROW), EmptyPanel(G_id.ROW) ? null : apirow.column);
        //基本情報保存
        Savestorage(corpkey, account, statusKey(G_id.BASE), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }
    function EmptyPanel(id, type) {
        try {
            return isEmpty(columns.find(e => e.logpid === id));
        } catch { return false; }
    }
    //パネル別列情報取得
    function tabletype(id) {
        if (id.substr(0, 1) === "T") {  //Total
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panel.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }

    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, statusKey(G_id.BASE));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            switch (panel[p].id) {
                case G_id.BASE:
                    if (setbase) break;
                    let fds = textfields.filter(x => !x.hide);
                    for (let f = 0; f < fds.length; f++) {
                        coldef.push({
                            headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                            type: fds[f].type
                        });
                    }
                    setbase = true;
                    break;
                case G_id.ROW:
                    cols = AGRef.current.GetshownColDef(apirow.column);
                    break;
                default:
                    continue;
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    var type = tabletype(G_id.ROW);
                    var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    colRef.current = coldef;
                    type = tabletype(G_id.TOTAL);
                    coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === "1") return all;   //全在庫拠点の場合非表示
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }
    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    //基本情報
    function width(value) {
        if (windowDimensions.width <= 600) {
            return '100%';
        }
        if (windowDimensions.width <= 900) {
            let size = ["50%", "50%", "100%", "100%"];
            return size[value];
        } else {
            let size = ["25%", "50%", "75%", "100%"];
            return size[value];
        }
    }
    function ChangeWidth(def, deltaY) {
        let newdata = DeepCopy(textfields);
        let col = newdata.find(e => e.columnid === def.columnid && e.type === def.type);
        if (isEmpty(col)) return;
        if (deltaY > 0) {   //-
            if (col.width === 0) return;
            col.width -= 1;
        } else {            //+
            if (col.width === 3) return;
            col.width += 1;
        }
        settextfields(newdata);
    }

    //Basic Data Change
    function ValueChanged(id, value) {
        if (id === "ft_invfix_isall") {
            setall(value==="1");
        }
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    //基本項目入れ替え
    const onSortEnd = ({ oldIndex, newIndex }, e) => {
        let type = e.target.parentNode.id.replace('basepanel', '');
        let idx = 0;
        for (let i = 0; i < textfields.length; i++) {
            if (textfields[i].type === type) {
                idx = i; break;
            }
        };
        settextfields(arrayMove(textfields, oldIndex + idx, newIndex + idx));
    };
    function shouldCancelStart(e) {
        //Label以外ソート不可
        if (e.target.className !== 'fieldlabel') return true;
    }
    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    const SortableItem = SortableElement(({ value }) => (
        <div style={{ boxSizing: 'border-box', width: width(value.width), border: 'solid 1px #ccc' }}>
            <div className='fieldlabel' style={{ cursor: 'context-menu', backgroundColor: themestyle.header.back, color: themestyle.header.color }}>
                {value.columnnm}
            </div>
            < div className={'fieldinput'} style={{ position: 'relative', backgroundColor: value.locked || ((value.primary || value.unchange) && formstatus === 'ENTRY FORM') ? '#eee' : (value.required ? themestyle.body.require : 'inset') }}>
                <EntryInput
                    def={value}
                    dataRef={entrydataRef}
                    textfields={textfields}
                    fnc={fnc}
                    changewidth={ChangeWidth}
                    ValueChanged={ValueChanged}
                />
                {warning(value) ? <WarnTip msg={warndescription.find(e => e.rowid === "0" && e.col === value.columnid).message} conv={false} /> : null}
            </div >
        </div>
    ));
    const SortableList = SortableContainer(({ items }) => {
        return (
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: 'left' }}>
                {items.map((value, index) => (
                    <SortableItem key={`item-${index}`} index={index} value={value} disabled={layoutlock}/>
                ))}
            </div>
        );
    });
    function warning(value) {
        if (warndescription.length === 0) return false;
        const warn = warndescription.find(e => e.rowid === "0" && e.col === value.columnid);
        if (!isEmpty(warn)) {
            return true;
        }
    }
    function WarnTip(param) {
        return (
            <Tooltip title={param.msg}>
                <div style={{ position: 'absolute', top: -2, left: -2, cursor: 'pointer' }}>
                    {param.conv ? < span class="material-icons convert">check_circle</span> : < span class="material-icons warning">announcement</span>}
                </div>
            </Tooltip>
        );
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock} />
                ))}
            </ul>
        );
    });
    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <SortableList
                        axis={"xy"}
                        items={textfields.filter(e => e.type === props.panel.type)}
                        onSortEnd={onSortEnd}
                        distance={1}
                        shouldCancelStart={shouldCancelStart}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.ROW) {
            return (
                <React.Fragment>
                    <EntryGrid
                        id={props.panel.id}
                        elemid="rowGrid"
                        entrydataRef={entrydataRef}
                        dataRef={rowsRef}
                        columnRef={colRef}
                        columninfo={columninfo}
                        columns={columns}
                        type={tabletype(G_id.ROW)}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        statusKey={formid + "entry_" + G_id.ROW}
                        ValueChanged={ChangeRowValue}
                    />
                </React.Fragment>
            );
        }
        return null;

    }
    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name === '' ? <div style={{ display: 'inline-block', height: 10 }}></div> : p.name}
                                    {p.name2 !== '' ? '-' : ''}
                                    <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== '0' || layoutlock  ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <Contents panel={p} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                entrycallback={MenuAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                parentedit={true}
                navmenu={navmenu}
                suppressaction={suppressaction}
                lockcell={ListlockCell}
                slipsave={true}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.2,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
        </div>
    );
};
